//
//

import i18n from "@/i18n/index";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { uid, date } from "quasar";
import { eventBus, publishAppPermissions } from "@/assets/js/appFunc";
import noCatPage from "@/components/Catalogs/NoCatPage/noCatPage.vue";

import { CATALOGS_DATE_LINE_FORMAT, CATALOGS_DATE_TIME_LINE_FORMAT_SHOW,
    CATALOGS_TIME_LINE_FORMAT, CATALOGS_TIME_LINE_FORMAT_SHOW, APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQDatetime from "@/components/Generics/AQDatetime/AQDatetime.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import deleteS from "@/assets/images/Buttons/deleteS.svg";
import deleteHoverNoBg from "@/assets/images/Buttons/deleteHoverNoBg.svg";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import EditCatModal from "../editCatModal/editCatModal.vue";
import ImportExportModal from "../importExportModal/importExport.vue";

export default {
    name: "CatalogDetails",
    components: {
        noCatPage,
        ImportExportModal,
        EditCatModal,
        AQInput,
        AQDatetime,
        AQButton,
        AQDataTable,
        AQMenu,
        AQBadge,
        AQDialog,
        AQDropdown,
        AQRadio,
        AQSearch,
        AQModal,
        AQHistory
    },
    props: {
        loadCatalogIndex: { type: Number, default: -1 },
        newCatWasAdded: { type: Boolean, default: false }
    },
    data() {
        return {
            tableData: [],
            currentRow: "",
            search: "",
            optionExport: "xls",
            exportCatalog: false,
            finalModelToSend: [],
            showEditModal: false,
            deleteIcon: deleteS,
            deleteHoverNoBg,
            rowsPerPage: 10,
            currentPage: 1,
            totalPages: 1,
            showModal: false,
            readonly: "",
            colArray: {},
            modelToSave: [],
            showMenu: [],
            dataActiveFromImp: false,
            resetCurrentPage: false,
            catalogsTotalPages: 1,
            selectedRowOnHover: null,
            deleteRowDialog: false,
            showDialogDirty: false,
            deleteColumn: {
                name: "deleteColumn",
                default: true,
                align: "center",
                label: "",
                field: "column0",
                visible: true,
                id: uid()
            },
            referenceCatalogBoolean: [
                {
                    value: "true",
                    label: this.$t("catalogs.true")
                },
                {
                    value: "false",
                    label: this.$t("catalogs.false")
                }
            ],
            originalTableData: [],
            refreshToast: null,
            hasUpdate: false,
            saveHistoryCatModal: false,
            keyUpdateCat: 0,
            saveHistoryCatHasMoreItems: true,
            saveHistoryData: [],
            saveHistoryCurrentPage: 0,
            saveHistoryActiveCommitId: null,
            currentPreviewData: null,
            timeStampPreview: null,
            isPreview: false,
            initialCatalogData: null,
            restoreConfirmationDialog: false,
            restoredCatData: null,
            previewDone: false,
            openDialogDraftPreview: false,
            savePreviewToast: null,
            note: null,
            createNote: false,
            noteDialogTitle: "",
            noteDialog: false,
            confirmLabel: null,
            standaloneTypes: new Set(["publish", "delete", "recover"]),
            actionMade: false
        };
    },

    computed: {
        ...mapGetters("catalogs", [
            "items",
            "getFromImportExcel",
            "selectedCatalogName",
            "selectedCatalogData",
            "selectedCat",
            "dataFromImport",
            "existingCatalogsAsList",
            "columnsForData",
            "noDataCatToShow",
            "unsavedChanges",
            "catalogsAlreadySaved",
            "getMasterId",
            "getCommitId",
            "getNewCatalog"
        ]),
        ...mapGetters("main", ["interfaceDirty"]),
        ...mapGetters("apps", ["currentApp", "processList"]),
        getCatalogsProps() {
            return {
                atId: "catalog-table",
                columns: this.columns,
                tableData: this.tablePage,
                totalPages: this.totalPages,
                resetCurrentPage: this.resetCurrentPage,
                setNewCurentPage: this.currentPage,
                noDataBasicTable: !!this.tableData.length,
                separator: "cell",
                rowColorSeparator: true,
                noDataDefaultTableHeight: "100%"
            };
        },
        currentPageHasNoData() {
            return !this.tablePage.length;
        },
        readonlyCell() {
            return !(this.isOwner || this.canWriteCD) || !this.$oneAtATime.state.$currentRoomEmpty || this.previewDone;
        },
        tablePage() {
            let filteredTableData = [];
            if (this.search) {
                filteredTableData = this.tableData.filter(item => (item.code || "").toLowerCase().includes(this.search.toLowerCase()));
            } else {
                filteredTableData = this.tableData;
            }
            this.setTotalPages(filteredTableData);
            const start = (this.currentPage - 1) * this.rowsPerPage;
            const end = this.currentPage * this.rowsPerPage;
            return filteredTableData.slice(start, end);
        },
        noDataCatToShow() {
            return (!this.items || !this.items.length) || (!this.items.some(item => !item.removed));
        },
        columns() {
            const columns = [{ ...this.deleteColumn }];
            let arrayForCols = [];
            const primitives = ["String", "Date", "Time", "DateTime", "Integer", "Boolean", "Decimal"];
            arrayForCols = (this.selectedCatalogData.fields || this.selectedCatalogData) || [];
            if (arrayForCols) {
                arrayForCols.forEach(el => {
                    if (el) {
                        columns.push({
                            name: el.name,
                            label: el.name,
                            required: true,
                            type: primitives.includes(el.type) ? el.type : "String",
                            visible: true,
                            field: el.name,
                            align: "left",
                            default: el.name === "code" || el.name === "name",
                            isExstCat: this.existingCatalogsAsList.filter(cat => cat.value === el.type).length
                        });
                    }
                });
            }

            return columns;
        },
        canWriteCD() {
            return (
                this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("CD")
                && this.$route.params.permissions.permissionsData.CD === "w"
            );
        },
        canWriteCS() {
            return (
                this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("CS")
                && this.$route.params.permissions.permissionsData.CS === "w"
            );
        },
        canPublishPermission() {
            return (
                this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("PA")
                && this.$route.params.permissions.permissionsData.PA === "w"
            );
        },
        isOwner() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("owner") ? this.$route.params.permissions.owner : null;
        },
        createNoteDisabled() {
            return !this.note && this.createNote;
        },
        showInfoExport() {
            return (this.optionExport === "xls" && this.selectedCatalogName.length > 31);
        }
    },
    watch: {
        "$backendWebsocketEvents.state.refreshCatList": function (value) {
            if (value) {
                const vm = this;
                const { data } = value;
                const eventInfo = data.split(":");
                const catId = eventInfo[2];
                const actionType = eventInfo[3];
                const catalogName = eventInfo[eventInfo.length - 1];
                if (actionType === "update" || actionType === "persistData" || actionType === "import") {
                    // daca sunt pe acelasi catalog
                    if (catId === vm.selectedCat.id && !vm.$oneAtATime.state.$currentRoomEmpty) {
                        this.showRefreshToast(catalogName, catId);
                        // daca sunt pe cataloage diferite
                    } else if (catId !== vm.selectedCat.id) {
                        const catalogUpdate = this.items.find(el => el.id === catId);
                        this.showListUpdate(catalogUpdate);
                    }
                } else if (actionType === "delete") {
                    // daca sunt pe acelasi catalog
                    if (catId === this.selectedCatalogData.id && !this.$oneAtATime.state.$currentRoomEmpty) {
                        this.$toast.showNotify({
                            type: "info",
                            message: `The ${catalogName} catalog has been deleted by
                                ${this.$oneAtATime.state.$currentEditingUser}.`,
                            timeout: 3000
                        });
                        this.$store.commit("catalogs/setSelectedCat", []);
                        this.$oneAtATime.destroyCurrentRoom();
                        this.$root.$emit("setReadonlyTag", false);
                        this.getCatList();
                        this.$emit("deleteOnSameCat");
                        eventBus.$emit("setDefaultState", true);
                        this.$router.replace({ path: `/applications/${this.currentApp.id}/catalogs`, params: {} });
                        // daca sunt pe cataloage diferite
                    } else if (catId !== this.selectedCat.id) {
                        this.showListUpdate();
                    }
                }
                this.$backendWebsocketEvents.state.refreshCatList = false;
            }
        },
        selectedCat: {
            handler() {
                const totalNumber = this.tableData.length;
                if (totalNumber > this.rowsPerPage) {
                    this.totalPages = Math.ceil(totalNumber / this.rowsPerPage);
                } else {
                    this.totalPages = 1;
                }

                this.currentPage = 1;
                this.colArray = [];
                this.resetCurrentPage = true;
                setTimeout(() => {
                    this.resetCurrentPage = false;
                }, 0);
            },
            deep: true,
            immediate: true
        },
        dataFromImport: {
            handler() {
                this.dataActiveFromImp = false;
            }
        },
        loadCatalogIndex: {
            handler(value) {
                if (value !== -1) {
                    this.setCurrentFirstCatalog(value);
                }
            },
            immediate: true
        },
        selectedCatalogData: {
            handler() {
                if (!this.tableData.length || this.dataFromImport.length || this.getFromImportExcel
                || (this.tableData[0].type !== this.selectedCatalogName) || this.hasUpdate || this.isPreview) {
                    this.tableData = this.filterSelectedCatalogData();
                    if ((!this.initialCatalogData && Object.keys(this.selectedCatalogData).length) || (!this.interfaceDirty && !this.isPreview)) {
                        this.initialCatalogData = JSON.parse(JSON.stringify(this.selectedCatalogData));
                    }
                    if (this.isPreview) {
                        this.isPreview = false;
                    }
                    if (this.getFromImportExcel) {
                        this.$store.commit("catalogs/setFromImportExcel", false);
                    }
                }
                this.$root.$emit("disableSaveButton", false);
            },
            deep: true,
            immediate: true
        },
        tableData: {
            handler() {
                this.finalModelToSend = [];
                if (this.dataFromImport.length > 0 && !this.dataActiveFromImp) {
                    const dataFromImportToAdd = this.dataFromImport.filter(el => el.hasOwnProperty("columns"));
                    this.modelToSave.push(...dataFromImportToAdd);
                    this.dataActiveFromImp = true;
                }
                this.modelToSave = this.tableData;
                for (let i = 0; i < this.modelToSave.length; i++) {
                    if (this.finalModelToSend.indexOf(this.modelToSave[i]) === -1) {
                        this.finalModelToSend.push(this.modelToSave[i]);
                    }
                }
                this.modelToSave = this.finalModelToSend;
                if (!this.originalTableData.length || (this.finalModelToSend.length && this.originalTableData[0].type !== this.finalModelToSend[0].type)) {
                    this.originalTableData = JSON.parse(JSON.stringify(this.finalModelToSend));
                }
                const defaultState = JSON.stringify(this.finalModelToSend) !== JSON.stringify(this.originalTableData);
                if (this.currentRow.code) {
                    this.$store.commit("catalogs/setUnsavedChanges", this.finalModelToSend.length ? this.finalModelToSend : "fromDelete");
                    this.currentRow = "";
                } else if (defaultState) {
                    this.$store.commit("catalogs/setUnsavedChanges", this.finalModelToSend);
                } else {
                    this.$store.commit("catalogs/setUnsavedChanges", []);
                }
                const totalNumber = this.tableData.length;
                if (totalNumber > this.rowsPerPage) {
                    this.totalPages = Math.ceil(totalNumber / this.rowsPerPage);
                } else {
                    this.totalPages = 1;
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.$root.$on("updatedCatalog", () => {
            this.tableData = this.filterSelectedCatalogData();
        });
        this.$root.$on("startEditing", () => {
            this.updateCatalogData();
        });
    },
    deactivated() {
        this.setNewCatalog(false);
        if (this.savePreviewToast) {
            this.savePreviewToast();
        }
        if (this.refreshToast) {
            this.refreshToast();
        }
    },
    created() {
        this.tableData = this.filterSelectedCatalogData();
        this.$root.$on("catalogsSave", () => {
            let found = false;
            const savePayload = JSON.parse(JSON.stringify(this.finalModelToSend));
            for (let i = 0; i < savePayload.length; i++) {
                if (savePayload[i].columns) {
                    Object.keys(savePayload[i].columns).forEach(key => {
                        if (savePayload[i].columns[key] === null) {
                            savePayload[i].columns[key] = "";
                        }
                    });
                }
            }
            this.$store.commit("catalogs/setUnsavedChanges", savePayload);
            for (let i = 0; !found && i < this.unsavedChanges.length; i++) {
                if (!found) {
                    if (!this.unsavedChanges[i].code || (this.unsavedChanges[i].name && !this.unsavedChanges[i].name.en)) {
                        this.$root.$emit("showCheckedSaveBtn", { showSaveBtn: false, persistSaveBtnState: true });
                        this.$toast.showNotify({
                            message: this.$t("catalogs.emptyRow"),
                            type: "error"
                        });
                        found = true;
                    } else if (this.unsavedChanges[i].code && this.unsavedChanges[i].code.length > 50) {
                        this.$root.$emit("showCheckedSaveBtn", { showSaveBtn: false, persistSaveBtnState: true });
                        this.$toast.showNotify({
                            message: this.$t("catalogs.maxCodeLength"),
                            type: "error"
                        });
                        found = true;
                    }
                }
            }
            if (!found) {
                if (this.isOwner || this.canWriteCS) {
                    this.saveCatalogValues();
                } else if (this.canWriteCD || this.canPublishPermission) {
                    this.$store.commit("main/setInterfaceDirty", false);
                    this.saveCatalogValues();
                }
            }
        });
        this.$root.$on("openSaveHistory", () => {
            if (this.saveHistoryActiveCommitId) {
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.actionMade = false;
                this.saveHistoryCatModal = true;
                this.$nextTick(() => {
                    const activePreviewListItem = document.querySelectorAll(".timeline_list_item.active.edit");
                    if (activePreviewListItem.length) {
                        activePreviewListItem[0].scrollIntoView();
                    }
                });
            } else {
                this.resetSaveHistory();
                this.getSaveHistoryCat();
            }
        });
        this.$root.$on("previewSaveHistoryClose", routeName => {
            if (routeName === this.$route.name) {
                if (this.savePreviewToast) {
                    this.savePreviewToast();
                }
                this.saveHistoryActiveCommitId = null;
                this.$store.commit("main/setInterfaceDirty", false);
                this.$root.$emit("hideSaveBtn", false);
                this.isPreview = true;
                this.$store.commit("catalogs/setSelectedCat", this.initialCatalogData);
                this.$store.commit("catalogs/setSelectedCatalogData", this.initialCatalogData);
                this.setTableDetails(this.initialCatalogData.data);
                this.timeStampPreview = null;
                this.previewDone = false;
                this.$root.$emit("showCheckedSaveBtn", true);
                this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
                    showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            }
        });
        this.$root.$on("restore", () => {
            this.infoRestoreDialog();
            this.restoreConfirmationDialog = true;
        });
        this.$root.$on("openNoteDialog", routeName => {
            if (routeName === this.$route.name) {
                this.getNoteData();
            }
        });
        this.$root.$on("bc__catalogs__open", () => {
            this.initialCatalogData = null;
            this.previewDone = false;
            this.resetSaveHistory();
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                ? !this.currentApp.nrOfProcesses : !this.processList.length,
            showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
        });
        this.$root.$on("showMoreSaveHistory", () => {
            this.saveHistoryCurrentPage += 1;
            this.getSaveHistoryCat();
        });
    },
    destroyed() {
        this.$root.$off("openSaveHistory");
        this.$root.$off("catalogsSave");
        this.$root.$off("startEditing");
        eventBus.$off("catListLoaded");
        this.$root.$emit("previewSaveHistoryHeaderClose", this.$route.name);
    },
    methods: {
        ...mapActions("catalogs", ["getTableDetails", "saveAllModifiedCats", "saveCatalogAll",
            "getCatDetails", "deleteCatalog", "getCatList", "expCatExcel", "expCatJson", "getHistoryCatPreviewData"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        ...mapActions("components", ["getHistoryData", "saveDeleteNote", "getNote"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapMutations("catalogs", ["setCatalogsAlreadySaved", "setTableDetails", "setNewCatalog"]),
        publishAppPermissions,
        showRefreshToast(catalogName) {
            if (!this.refreshToast) {
                this.refreshToast = this.$toast.showNotify({
                    type: "info",
                    message: `${catalogName} ${this.$t("userInterface.updateInterface")}`,
                    buttonLabel: this.$t("userInterface.refresh"),
                    timeout: 0,
                    hasClose: false,
                    actionEvent: this.updateCatalogData
                });
            }
        },
        showDeleteIcon(index) {
            this.selectedRowOnHover = index.rowIndex;
        },
        hideDeleteIcon() {
            this.selectedRowOnHover = null;
        },
        showListUpdate(catalogUpdated) {
            if (!catalogUpdated) {
                this.getCatList();
            } else {
                this.$toast.showNotify({
                    type: "info",
                    message: `${catalogUpdated.name}  ${this.$t("catalogs.contentUpdated")}`,
                    timeout: 1000
                });
            }
        },
        updateCatalogData() {
            this.hasUpdate = true;
            if (this.selectedCat && this.selectedCat.id) {
                this.getTableDetails(this.selectedCat).then(() => {
                    if (this.currentPageHasNoData && this.currentPage > 1) {
                        this.changePagination({ rowsPerPage: this.rowsPerPage, page: this.currentPage - 1 });
                    }
                });
                this.refreshToast = null;
            }
        },
        modalClosed() {
            if (this.showEditModal) {
                this.showEditModal = false;
            } else {
                this.showModal = false;
            }
        },
        setInitialPage() {
            this.currentPage = 1;
        },
        checkFreshAppData() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
            });
        },
        saveCatalogValues() {
            const dataToSave = [];
            if (this.unsavedChanges && this.unsavedChanges.length) {
                this.unsavedChanges.forEach(element => {
                    dataToSave.push({
                        code: element.code,
                        name: element.name,
                        columns: element.columns
                    });
                });
            }
            const payload = {
                id: this.selectedCat.id,
                applicationId: this.currentApp.id,
                name: this.selectedCat.name,
                description: this.selectedCat.description,
                fields: this.selectedCat.fields || this.selectedCatalogData.fields,
                data: dataToSave,
                commitId: this.getCommitId,
                masterId: this.getMasterId,
                active: typeof this.selectedCat.active === "boolean" ? this.selectedCat.active : true
            };
            this.originalTableData = payload.data;
            this.saveCatalogAll(payload).then((data) => {
                this.$store.commit("catalogs/setCommitId", data.data.commitId);
                this.$store.commit("catalogs/setMasterId", data.data.masterId);
                this.setNewCatalog(false);
                this.$root.$emit("showCheckedSaveBtn", true);
                this.$store.commit("main/setInterfaceDirty", false);
                this.$store.commit("catalogs/setUnsavedChanges", []);
                this.$store.commit("catalogs/setCatalogsAlreadySaved", true);
                this.$store.commit("catalogs/setFromImportExcel", false);
                this.$store.commit("catalogs/setSelectedCat", payload);
                this.$store.commit("catalogs/setSelectedCatalogData", payload);
                this.checkFreshAppData();
                this.initialCatalogData = JSON.parse(JSON.stringify(this.selectedCatalogData));
                this.$toast.showNotify({
                    type: "success",
                    message: this.$t("generic.savedSuccessfully"),
                    timeout: 500
                });
            },
            () => {
                this.$root.$emit("showCheckedSaveBtn", false);
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("generic.saveUnsuccessful"),
                    timeout: 1000
                });
            });
        },
        setTotalPages(data) {
            this.totalPages = Math.ceil(data.length / this.rowsPerPage) || 1;
        },
        filterSelectedCatalogData() {
            let catalogData = [];
            if (this.selectedCatalogData && this.selectedCatalogData.data) {
                catalogData = this.selectedCatalogData.data
                    .map(elem => ({
                        code: elem.code,
                        name: { en: elem.name.hasOwnProperty("en") ? elem.name.en : elem.name },
                        columns: elem.columns,
                        type: this.selectedCatalogName
                    }));
            }
            this.hasUpdate = false;
            return catalogData;
        },
        confirmDeleteRow(row) {
            if (!this.readonlyCell) {
                this.deleteRowDialog = true;
                this.currentRow = row;
            }
        },
        getMaskFormat(type, model) {
            const formatMap = {
                Time: model ? CATALOGS_TIME_LINE_FORMAT : CATALOGS_TIME_LINE_FORMAT_SHOW,
                Date: CATALOGS_DATE_LINE_FORMAT,
                DateTime: CATALOGS_DATE_TIME_LINE_FORMAT_SHOW
            };
            return formatMap[type] || "";
        },
        changePagination({ rowsPerPage, page }) {
            this.rowsPerPage = rowsPerPage;
            this.currentPage = page;
            this.totalPages = Math.ceil(this.tableData.length / this.rowsPerPage) || 1;
        },
        headerMenu() {
            const optionsList = [];
            if (this.isOwner || this.canWriteCS) {
                optionsList.push(
                    {
                        value: "edit",
                        label: this.$t("catalogs.editCat"),
                        leftIcon: { name: "edit", size: "16px" },
                        itemDisabled: !this.$oneAtATime.state.$currentRoomEmpty || this.previewDone
                    }
                );
            }
            if (this.isOwner || this.canWriteCD) {
                optionsList.push(
                    {
                        value: "export",
                        label: this.$t("catalogs.importExport.exportData"),
                        leftIcon: { name: "download", size: "16px" },
                        itemDisabled: this.getNewCatalog,
                        tooltipProps: this.getNewCatalog
                            ? { tooltipContent: this.$t("catalogs.importExport.alertTooltip"), direction: "left" }
                            : null
                    },
                    {
                        value: "import",
                        label: this.$t("catalogs.importExport.importData"),
                        leftIcon: { name: "upload", size: "16px" },
                        itemDisabled: !this.$oneAtATime.state.$currentRoomEmpty || this.previewDone || this.getNewCatalog,
                        tooltipProps: this.getNewCatalog
                            ? { tooltipContent: this.$t("catalogs.importExport.alertTooltip"), direction: "left" }
                            : null
                    }
                );
            }
            return optionsList;
        },
        defaultColTypeVal(val) {
            let returnType = null;
            if (val && val.length) {
                if (typeof val === "object") {
                    returnType = val[0].value;
                } else {
                    returnType = val;
                }
            }
            return returnType;
        },
        setVal({ row, col, val }) {
            if (val && val.length) {
                this.tablePage[row].columns[col] = val[0].value;
            } else {
                this.tablePage[row].columns[col] = "";
            }
            this.$store.commit("main/setInterfaceDirty", true);
            this.$nextTick(() => {
                this.$root.$emit("showCheckedSaveBtn", false);
            });
        },
        getTypeDateTime(colType) {
            return colType.toLowerCase();
        },
        setBadgeType(col) {
            return col.type || "String";
        },
        selectedOption($event) {
            if ($event[0].value === "edit") {
                this.editCatModal();
            } else if ($event[0].value === "export") {
                this.exportCatalog = true;
            } else if ($event[0].value === "import") {
                if (this.interfaceDirty) {
                    this.showDialogDirty = true;
                } else {
                    this.importExport();
                }
            }
        },
        dirtyAction(fromOk) {
            this.showDialogDirty = false;
            if (fromOk) {
                this.importExport();
            }
        },
        exitCell() {
            this.$store.commit("main/setInterfaceDirty", true);
            this.$root.$emit("disableSaveButton", false);
        },
        activateSaveBtn() {
            this.$nextTick(() => {
                this.$root.$emit("showCheckedSaveBtn", false);
            });
        },
        exportCatalogAction() {
            const currApp = this.currentApp;
            this.$store.commit("catalogs/setCurrApp", currApp);
            const payload = JSON.parse(JSON.stringify(this.selectedCatalogData));
            if (typeof this.unsavedChanges === "object") {
                if (this.unsavedChanges.length) {
                    payload.data = this.unsavedChanges;
                }
            } else if (typeof this.unsavedChanges === "string") {
                payload.data = [];
            }
            if (this.optionExport === "xls") {
                this.expCatExcel(payload);
            } else {
                this.$store.commit("catalogs/setFromCatList", false);
                this.expCatJson(payload);
            }
            this.exportCatalog = false;
        },
        cancelExport() {
            this.exportCatalog = false;
        },
        addNewRow() {
            this.$root.$emit("disableSaveButton", false);
            let noEmptyRows = true;
            const catData = this.tableData;
            if (this.dataFromImport) {
                this.dataActiveFromImp = true;
            }
            for (let i = 0; i < catData.length; i++) {
                if ((!catData[i].code || !catData[i].name.en)) {
                    noEmptyRows = false;
                    break;
                }
            }
            if (noEmptyRows) {
                this.columns.forEach(element => {
                    if (element.name !== "name" && element.name !== "code" && element.name !== "deleteColumn") {
                        this.colArray[element.name] = "";
                    }
                });
                const newObject = {
                    code: "",
                    id: uid(),
                    name: { en: "" },
                    type: this.selectedCatalogName
                };
                if (catData.length && catData.length % this.rowsPerPage === 0) {
                    if (this.totalPages === this.currentPage) {
                        this.changePagination({ rowsPerPage: this.rowsPerPage, page: this.currentPage + 1 });
                    } else {
                        this.changePagination({ rowsPerPage: this.rowsPerPage, page: this.totalPages + 1 });
                    }
                } else {
                    this.changePagination({ rowsPerPage: this.rowsPerPage, page: this.totalPages });
                }
                this.$store.commit("main/setInterfaceDirty", true);
                this.$root.$emit("showCheckedSaveBtn", false);
                this.$set(newObject, "columns", { ...this.colArray });
                this.tableData.push(newObject);
            } else {
                this.$toast.showNotify({
                    message: `${this.$t("catalogs.addNewCat.alreadyEmptyRow")}`,
                    type: "error"
                });
            }
        },

        showErrorToast(activeColDetail, rowDetail) {
            this.$toast.showNotify({
                message: `${this.$t("catalogs.onlyTypeValAllowed", { name: activeColDetail.type })}`,
                type: "error"
            });
            rowDetail.columns[activeColDetail.label] = "";
        },
        checkDuplicatedData(rowDetail, colsDetail, activeColDetail) {
            if ((rowDetail.code && rowDetail.code.charAt(0) === " ") || (rowDetail.name.en && rowDetail.name.en.charAt(0) === " ")) {
                this.$toast.showNotify({
                    message: `${this.$t("catalogs.addNewCat.activeSpaceData")}`,
                    type: "error"
                });
                if (activeColDetail.label === "code") {
                    rowDetail.code = "";
                } else {
                    rowDetail.name.en = "";
                }
            } else if (activeColDetail.label === "code" && rowDetail.code && rowDetail.code.length > 50) {
                this.$toast.showNotify({
                    message: `${this.$t("catalogs.maxCodeLength")}`,
                    type: "error"
                });
                rowDetail.code = "";
            } else {
                this.$store.commit("main/setInterfaceDirty", true);
                this.$root.$emit("showCheckedSaveBtn", false);
                this.$root.$emit("disableSaveButton", false);
                const catData = this.tableData;
                for (let i = 0; i < catData.length; i++) {
                    const colsToCheck = catData[i].columns;
                    Object.keys(colsToCheck).some(key => {
                        const numberToCheck = Number(colsToCheck[key]);
                        const { label, type } = activeColDetail;
                        let error = false;
                        if (key === label && rowDetail.code === catData[i].code) {
                            if (type === "Integer") {
                                if (!Number.isInteger(numberToCheck)) {
                                    this.showErrorToast(activeColDetail, rowDetail);
                                    error = true;
                                }
                            } else if (type === "Decimal") {
                                if (colsToCheck[key] && !colsToCheck[key].includes(".")) {
                                    if (Number.isInteger(Number(colsToCheck[key]))) {
                                        rowDetail.columns[activeColDetail.label] = Number(rowDetail.columns[activeColDetail.label]).toFixed(2);
                                    } else if (colsToCheck[key]) {
                                        this.showErrorToast(activeColDetail, rowDetail);
                                        error = true;
                                    }
                                } else if (colsToCheck[key] && !Number.isNaN(+colsToCheck[key])) {
                                    rowDetail.columns[activeColDetail.label] = Number(rowDetail.columns[activeColDetail.label]).toFixed(2);
                                } else if (colsToCheck[key]) {
                                    this.showErrorToast(activeColDetail, rowDetail);
                                    error = true;
                                }
                            }
                        }
                        return error;
                    });
                    if (catData[i].id !== rowDetail.id && rowDetail.code && catData[i].code === rowDetail.code) {
                        this.$toast.showNotify({
                            message: this.$t("catalogs.addNewCat.errorExistingCode"),
                            type: "error"
                        });
                        rowDetail.code = "";
                    }
                }
            }
        },
        checkEmptyData(rowDetail, colsDetail, activeColDetail) {
            if (rowDetail.columns[activeColDetail.label] && rowDetail.columns[activeColDetail.label].charAt(0) === " ") {
                this.$toast.showNotify({
                    message: `${this.$t("catalogs.addNewCat.activeSpaceData")}`,
                    type: "error"
                });
                rowDetail.columns[activeColDetail.label] = "";
            }
        },
        importExport() {
            if (this.selectedCat.isNewCat && !this.catalogsAlreadySaved) {
                this.$toast.showNotify({
                    message: `${this.$t("catalogs.addNewCat.saveCatBeforeImport")}`,
                    type: "error"
                });
            } else {
                this.showModal = true;
                this.$emit("modalClosed", false);
            }
        },
        editCatModal() {
            this.$store.commit("catalogs/setTemporaryColumnsCache", this.columns);
            this.showEditModal = true;
            this.$store.commit("catalogs/setInEditCatalogColumns", this.columns);
        },
        okAction() {
            this.$root.$emit("disableSaveButton", false);
            this.$store.commit("main/setInterfaceDirty", true);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.deleteRowDialog = false;
            const filteredData = this.tableData;
            this.totalPages = Math.ceil(filteredData.length / this.rowsPerPage);
            const catalogIndex = this.tableData.findIndex(elem => elem.code === this.currentRow.code);
            this.tableData.splice(catalogIndex, 1);
            this.modelToSave = this.tableData;
            if (this.currentPageHasNoData && this.currentPage > 1) {
                this.changePagination({ rowsPerPage: this.rowsPerPage, page: this.currentPage - 1 });
            }
        },
        cancelAction() {
            this.deleteRowDialog = false;
        },

        setCurrentFirstCatalog(catIndex) {
            let indexForFirstCatToShow = 0;
            if (this.items && this.items.length > 0 && this.items[0] && !this.items[0].isNewCat) {
                for (let i = 0; i < this.items.length; i++) {
                    if (!this.items[i].removed) {
                        indexForFirstCatToShow = i;
                        break;
                    }
                }
                const loadThisCatalog = catIndex === 0 ? indexForFirstCatToShow : catIndex;
                this.$store.commit("catalogs/setSelectedCat", this.items[loadThisCatalog]);
                if (this.items[loadThisCatalog].commitId && !this.newCatWasAdded) {
                    this.getTableDetails(this.items[loadThisCatalog]);
                } else {
                    this.setTableDetails({ data: this.items[loadThisCatalog] });
                }
            }
        },
        cellInEdit() {
            this.$root.$emit("disableSaveButton", true);
        },
        exitCellEdit(rowDetail, colsDetail, activeColDetail, typeName) {
            this.checkDuplicatedData(rowDetail, colsDetail, activeColDetail, typeName);
            this.$root.$emit("disableSaveButton", false);
        },
        setInputCellClass(idx) {
            return idx % 2 === 0 ? "row-bg-white" : "row-bg-grey";
        },
        saveHistoryAction(event) {
            if (event === "close") {
                this.saveHistoryCatModal = false;
                this.savePreviewToast = this.timeStampPreview && (this.actionMade || this.previewDone) ? this.$toast.showNotify({
                    type: "info",
                    message: `${this.$t("versioning.previewToastTitle")} ${this.dateFormatter(this.timeStampPreview)}`,
                    caption: this.$t("versioning.previewToastText"),
                    code: "preview-ui",
                    timeout: 30000000
                }) : null;
                this.actionMade = false;
            }
        },
        getSaveHistoryCat() {
            if (this.saveHistoryCatHasMoreItems) {
                const payload = {
                    searchType: "SAVE_HISTORY",
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    elementId: this.selectedCat.id,
                    page: this.saveHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    this.actionMade = false;
                    this.saveHistoryData = this.saveHistoryData.concat(data.data.history);
                    this.saveHistoryCatHasMoreItems = data.data.hasMorePages;
                    this.saveHistoryCatModal = true;
                });
            } else {
                this.actionMade = false;
                this.saveHistoryCatModal = true;
            }
        },
        resetSaveHistory() {
            this.saveHistoryData = [];
            this.saveHistoryCurrentPage = 0;
            this.saveHistoryCatHasMoreItems = true;
            this.saveHistoryActiveCommitId = null;
            if (this.savePreviewToast) {
                this.savePreviewToast();
            }
        },
        getSaveHistoryItem(event) {
            console.log("ev", event);
            if (!this.standaloneTypes.has(event.commitType)) {
                this.actionMade = true;
                this.currentPreviewData = event;
                if (this.interfaceDirty) {
                    this.openDialogDraftPreview = true;
                } else {
                    this.getSaveHistoryCatPreview();
                }
            }
        },
        getSaveHistoryCatPreview() {
            if (!this.standaloneTypes.has(this.currentPreviewData.commitType)) {
                this.$root.$emit("previewSaveHistoryLoadStart", this.$route.name);
                const payload = {
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    elementId: this.selectedCat.id,
                    commitId: this.currentPreviewData.commitId
                };
                this.getHistoryCatPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("previewSaveHistoryLoadEnd", this.$route.name);
                        this.$root.$emit("hideSaveBtn", true);
                        this.$root.$emit("showPublish", false);
                        this.$store.commit("catalogs/setSelectedCat", data.data);
                        this.$store.commit("catalogs/setSelectedCatalogData", data.data);
                        this.$store.commit("main/setInterfaceDirty", false);
                        this.setTableDetails(data.data.data);
                        this.isPreview = true;
                        this.saveHistoryActiveCommitId = data.data.commitId || this.currentPreviewData.commitId;
                        this.timeStampPreview = data.data.timestamp;
                        this.previewDone = true;
                    } else {
                        this.$root.$emit("previewSaveHistoryClose", this.$route.name);
                    }
                });
            }
        },
        infoRestoreDialog(timelineItem) {
            this.restoredCatData = timelineItem || this.currentPreviewData;
            const restoreElementData = timelineItem && timelineItem.timestamp ? `${this.dateFormatter(timelineItem.timestamp)}`
                : `${this.dateFormatter(this.currentPreviewData.timestamp)}`;
            this.restoreDialogMessage = this.$t("versioning.restoreDialogInfoCat", { date: restoreElementData });
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(".") : "";
            const data = new Date();
            data.setMonth(newData[1] - 1);
            const year = newData[2].split(" ")[0];
            const hour = newData[2].split(" ")[1].substring(0, 5);
            return `${data.toLocaleString("en-US", { month: "long" })} ${newData[0]}, ${year}  ${i18n.t("versioning.at")} ${hour}`;
        },
        confirmRestore() {
            this.actionMade = true;
            if ((this.previewDone && this.restoredCatData && this.restoredCatData !== this.currentPreviewData) || !this.previewDone) {
                const payload = {
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    elementId: this.selectedCat.id,
                    commitId: this.restoredCatData.commitId
                };
                this.getHistoryCatPreviewData(payload).then(data => {
                    if (data && data.data) {
                        this.$root.$emit("hideSaveBtn", false);
                        this.$root.$emit("showCheckedSaveBtn", false);
                        this.$root.$emit("confirmRestore", this.$route.name);
                        this.isPreview = true;
                        this.$store.commit("catalogs/setSelectedCat", data.data);
                        this.$store.commit("catalogs/setSelectedCatalogData", data.data);
                        this.setTableDetails(data.data.data);
                        this.timeStampPreview = data.data.timestamp;
                        this.previewDone = false;
                    }
                });
            }
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                ? !this.currentApp.nrOfProcesses : !this.processList.length,
            showPublish: publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.saveHistoryActiveCommitId = null;
            this.resetSaveHistory();
            this.$store.commit("main/setInterfaceDirty", true);
            this.actionMade = false;
            this.saveHistoryCatModal = false;
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$root.$emit("confirmRestore", this.$route.name);
            this.previewDone = false;
            this.$toast.showNotify({
                type: "success",
                message: this.$t("versioning.confirmRestoreNotify"),
                timeout: 2000
            });
        },
        historyMenuClick(evt) {
            this.dialogAction = evt.actionName;
            if (this.dialogAction === "restore") {
                this.infoRestoreDialog(evt.timelineItem);
                this.restoreConfirmationDialog = true;
            }
        },
        actionNote(noteData) {
            const payload = {
                module: "Catalogs",
                applicationId: this.currentApp.id,
                elementId: this.selectedCat.id
            };
            payload.commitId = noteData ? noteData.timelineItem.commitId : this.currentPreviewData.commitId;
            payload.note = noteData ? noteData.note : this.note;
            let messageLabel = "";
            if (noteData) {
                messageLabel = this.dialogAction === "edit" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            } else {
                messageLabel = this.confirmLabel === "Update" ? this.$t("versioning.updateNoteDialog") : this.$t("versioning.saveNote");
            }
            this.saveDeleteNote(payload).then((data) => {
                if (data) {
                    this.$toast.showNotify({
                        type: "success",
                        message: messageLabel,
                        timeout: 500,
                        hasClose: true
                    });
                    if (noteData) {
                        noteData.timelineItem.note = noteData.note;
                        this.keyUpdateCat += 1;
                    } else if (this.currentPreviewData) {
                        this.currentPreviewData.note = this.note;
                    }
                }
            });
        },
        getNoteData() {
            if (this.currentPreviewData) {
                const payload = {
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    elementId: this.selectedCat.id,
                    commitId: this.currentPreviewData.commitId
                };
                this.getNote(payload).then(data => {
                    if (data) {
                        this.note = data.data;
                        this.createNote = !this.note;
                        this.confirmLabel = this.note ? this.$t("versioning.updateNote") : this.$t("versioning.createNote");
                        this.noteDialogTitle = this.note
                            ? this.$t("versioning.dialogTitleEdit", { date: `${this.dateFormatter(this.currentPreviewData.timestamp)}` })
                            : this.$t("versioning.dialogTitleCreate", { date: `${this.dateFormatter(this.currentPreviewData.timestamp)}` });
                    }
                    this.noteDialog = true;
                });
            }
        }
    }
};
